import { FC } from "react";
import { SaveIcon } from "../../../assets/icons/Icons";
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";
import { SaveButton } from "./TableElements.styles";
import { GeneralButton } from "../../../common/ui/GeneralButton";

interface SaveBtnProps {
  title?: string;
  handleOnClick: () => void;
  hoverText?: string;
}

const SaveBtn: FC<SaveBtnProps> = ({ title, handleOnClick, hoverText }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={hoverText ?? t("label.save")}>
      <GeneralButton appVariant="icon" onClick={handleOnClick}>
        <SaveIcon />
      </GeneralButton>
    </Tooltip>
  );
};

export default SaveBtn;
